module.exports = __webpack_public_path__ + "static/media/stress-scale.ccae1c9f.svg";